import PromptTypography from "../../PromptTypography";

const Pending = () => (
  <PromptTypography data-cy="TwoFA_Pending">
    Thank you for requesting to join! Once you have been approved by an admin,
    you&apos;ll be able to log in and continue.
  </PromptTypography>
);

export default Pending;
